export default "dist/images/block-columns-uneven-2.b62f738.png";